module.exports = __webpack_public_path__ + "static/media/demo2.4ad693c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/home/demo2.jpg
// module id = 697
// module chunks = 2